import { render, staticRenderFns } from "./ReportBarChart.vue?vue&type=template&id=0aec7816&scoped=true&"
import script from "./ReportBarChart.vue?vue&type=script&lang=ts&"
export * from "./ReportBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./ReportBarChart.vue?vue&type=style&index=0&id=0aec7816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aec7816",
  null
  
)

export default component.exports